import { render, staticRenderFns } from "./MainSiteOrganizer.vue?vue&type=template&id=283727e3&scoped=true&"
import script from "./MainSiteOrganizer.vue?vue&type=script&lang=js&"
export * from "./MainSiteOrganizer.vue?vue&type=script&lang=js&"
import style0 from "./MainSiteOrganizer.vue?vue&type=style&index=0&id=283727e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283727e3",
  null
  
)

export default component.exports